import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialpadWfm",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function f(e, t, r, u, p, a) {
  return l(), d("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--dialpad-wfm"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Dialpad Wfm",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 .501a1.5 1.5 0 0 0-.749.2l-3.5 2H1.75A1.5 1.5 0 0 0 1 4v4a1.5 1.5 0 0 0 .75 1.298l.002.001 3.498 1.999a1.5 1.5 0 0 0 1.5 0l3.498-1.999.002-.001A1.5 1.5 0 0 0 11 8V4a1.5 1.5 0 0 0-.75-1.298l-3.5-2h-.001A1.5 1.5 0 0 0 6 .5Zm-.25 1.067a.5.5 0 0 1 .5 0L9.49 3.42 6 5.423 2.51 3.42l3.238-1.85.002-.002ZM2 8a.5.5 0 0 0 .25.431L5.5 10.29v-4L2 4.28V8Zm7.933.25a.503.503 0 0 1-.183.182L6.5 10.289v-4L10 4.28V8a.5.5 0 0 1-.067.25Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const L = /* @__PURE__ */ s(c, [["render", f]]);
export {
  L as default
};
//# sourceMappingURL=dialpad-wfm.js.map
